import styled from 'styled-components';

export const DivTableUserRoles = styled.div.attrs({
  className: 'p-4 overflow-y-auto',
})`
  height: 20rem;
`;
